import React, { useState, useEffect } from 'react';
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Box,
  Typography,
  Chip
} from '@mui/material';
import { useAuth } from '../context/AuthContext';
import axios from 'axios';

const BranchSelector = ({ selectedBranchId, onBranchChange, label = "Select Branch" }) => {
  const { user, isSuperAdmin } = useAuth();
  const [branches, setBranches] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (isSuperAdmin()) {
      fetchBranches();
    }
  }, [isSuperAdmin]);

  const fetchBranches = async () => {
    try {
      setLoading(true);
      const token = localStorage.getItem('token');
      const response = await axios.get('/api/branches', {
        headers: { Authorization: `Bearer ${token}` }
      });
      setBranches(response.data);
    } catch (error) {
      console.error('Failed to fetch branches:', error);
    } finally {
      setLoading(false);
    }
  };

  // If not SuperAdmin, show current branch info only
  if (!isSuperAdmin()) {
    return (
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <Typography variant="body2" color="text.secondary">
          Current Branch:
        </Typography>
        <Chip 
          label={user?.branch?.displayName || 'No Branch'} 
          color="primary" 
          variant="outlined"
          size="small"
        />
      </Box>
    );
  }

  return (
    <FormControl fullWidth size="small" disabled={loading}>
      <InputLabel>{label}</InputLabel>
      <Select
        value={selectedBranchId || ''}
        onChange={(e) => onBranchChange(e.target.value)}
        label={label}
      >
        <MenuItem value="">
          <em>All Branches</em>
        </MenuItem>
        {branches.map((branch) => (
          <MenuItem key={branch._id} value={branch._id}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <Typography>{branch.displayName}</Typography>
              <Chip 
                label={branch.code} 
                size="small" 
                variant="outlined"
                sx={{ ml: 1 }}
              />
            </Box>
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default BranchSelector;